import api from './api';

export interface LeaderboardEntry {
  rank: number;
  userId: string;
  name: string;
  profilePicture?: string;
  total: number;
  game_1: number;
  game_2: number;
  game_3: number;
}

export const gamesService = {
  getLeaderboard: (): Promise<LeaderboardEntry[]> =>
    api.get('/games/leaderboard').then((res) => res.data),

  getMyScores: () =>
    api.get('/games/me').then((res) => res.data),

  updateScores: (dto: { game_1?: number; game_2?: number; game_3?: number }) =>
    api.post('/games/scores', dto).then((res) => res.data),
};
